/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { TableTokenHistory } from '@components/tables/token-history';
import { IToken } from '@interface/token';
import { RootState } from '@state/store';
import { getScreenName } from '@utils/user';
import { Box, Button } from '@versumstudios/ui';

interface IHistory {
  token: IToken;
}

export const History: FC<IHistory> = () => {
  const { history, creators } = useSelector((state: RootState) => state.token);
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;

  const parsed = history.map((user: any) => {
    const { buyer, seller } = user;
    return {
      ...user,
      // buyer
      buyerScreenName: getScreenName(
        buyer.user[0].user.verified_on_chain,
        buyer.user[0].user.screen_name,
        buyer.user[0].user.id,
        buyer.user[0].user.name
      ),
      buyerIsCreator: creators.filter((e: any) => e.wallet.address === buyer.address).length > 0,
      buyerIsYou: buyer.address === viewer,
      // seller
      sellerScreenName: getScreenName(
        seller.user[0].user.verified_on_chain,
        seller.user[0].user.screen_name,
        seller.user[0].user.id,
        seller.user[0].user.name
      ),
      sellerIsCreator: creators.filter((e: any) => e.wallet.address === seller.address).length > 0,
      sellerIsYou: seller.address === viewer,
    };
  });

  return (
    <Box
      css={{
        flexDirection: 'column',
        minHeight: 256,
      }}
    >
      <TableTokenHistory data={parsed} />

      {false && (
        <Box vertical horizontal css={{ padding: '$space$3' }}>
          <Button variant="secondary">Load more</Button>
        </Box>
      )}
    </Box>
  );
};
